import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Button, Nav, NavItem } from "reactstrap";
import Loader from "react-loaders";
import { api } from "../../_services/api.service";
import { userService } from "../../_services/user.service";
import PageTitle from "../../Layout/AppMain/PageTitle";
import GeneralGrid from "../../Components/GeneralGrid";
import { toast } from "react-toastify";
import DecisionNumberLineChart from "./Charts/DecisionNumberLineChart";
import AlternativeAverageBarChart from "./Charts/AlternativeAverageBarChart";
import ObjectiveAverageBarChart from "./Charts/ObjectiveAverageBarChart";
import QuestionResultsCard from "./Components/QuestionResultsCard";
import DecisionResultsModal from "./DecisionResultsModal";
import { NavLink } from "react-router-dom";
import colors from "../../_helpers/colors";
import PartnerAlternativeListModal from "../Alternative/PartnerAlternativeListModal";
import useModal from "../../_hooks/useModal.hook";
import AddUserModal from "./Modals/AddUserModal";
import UsersCard from "./Components/UsersCard";
import swal from "sweetalert";
import CopyTemplateModal from "./Modals/CopyTemplateModal";
import download from "downloadjs";

const DecisionTemplateResults = (props) => {
  const currentUser = userService.getLoggedInUser();
  const partnerId = parseInt(props.match.params.partnerId);
  let partnerScenarioId = parseInt(props.match.params.partnerScenarioId);
  let [scenarios, setScenarios] = useState(null);
  let [isLoading, setIsLoading] = useState(false);
  let [scenario, setScenario] = useState(null);
  let [activeTab, setActiveTab] = useState(1);
  const [users, setUsers] = useState([]);
  const [partner, setPartner] = useState(null);

  let [selectedUserData, setSelectedUserData] = useState(null);
  let [showResultsModal, setShowResultsModal] = useState(false);
  const [isSurveyReportLoading, setIsSurveyReportLoading] = useState(false);

  const [columns, setColumns] = useState([]);
  const { show: showCopyTemplateModa, toggle: toggleCopyTemplateModal } =
    useModal();

  let [showPartnerAlternativeListModal, setShowPartnerAlternativeListModal] =
    useState(false);
  let [
    partnerAlternativeListModalScenarioId,
    setPartnerAlternativeListModalScenarioId,
  ] = useState(0);

  const { show: showAddUserModal, toggle: toggleAddUserModal } = useModal();

  const toggleResultsModal = () => {
    setShowResultsModal(!showResultsModal);
  };

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setIsLoading(true);

      let sc = await api.getPartnerScenarioById(partnerScenarioId);
      setScenario(sc);
      await loadScenarios();
      await loadUsers();

      api.getPartnerById(partnerId).then((p) => {
        setPartner(p);
      });

      loadColumns(sc);
    } catch (err) {
      console.log(err);
      toast(`An error occured, ${err}`, {
        autoClose: 3000,
        type: toast.TYPE.ERROR,
        hideProgressBar: false,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const loadUsers = async () => {
    let p = await api.getUsersByPartnerScenario(partnerScenarioId);

    var uniqueEmails = [...new Set(p.map((x) => x.email))];
    var uniqueUsers = uniqueEmails.map((e) => p.find((x) => x.email == e));

    setUsers(uniqueUsers);
  };

  const loadScenarios = async () => {
    let scen = await api.getScenariosByPartnerScenario(partnerScenarioId);
    setScenarios(scen);
  };

  const loadColumns = (partnerScenario) => {
    let cols = [
      {
        dataField: "portfolio",
        text: "Name",
        sort: true,
        headerStyle: () => {
          return { width: "10%" };
        },
      },
      {
        dataField: "userEmail",
        text: "Email",
        sort: true,
        headerStyle: () => {
          return { width: "15%" };
        },
      },
      {
        dataField: "numObjectives",
        text: "# Objectives",
        sort: true,
        headerStyle: () => {
          return { width: "8%" };
        },
      },
      {
        dataField: "numAlternatives",
        text: "# Alternatives",
        sort: true,
        headerStyle: () => {
          return { width: "8%" };
        },
        formatter: (content, row) => {
          return (
            <a
              href="#"
              onClick={(e) => {
                e && e.preventDefault();
                setPartnerAlternativeListModalScenarioId(row.scenarioID);
                togglePartnerAlternativeListModal();
              }}
            >
              {content}
            </a>
          );
        },
      },
      {
        dataField: "numParticipants",
        text: "# Participants",
        sort: true,
        headerStyle: () => {
          return { width: "8%" };
        },
      },
      {
        dataField: "cr",
        text: "Consistency Ratio",
        sort: true,
        headerStyle: () => {
          return { width: "12%" };
        },
      },
      {
        dataField: "userPoints",
        text: "User Points",
        sort: true,
        headerStyle: () => {
          return { width: "8%" };
        },
      },
      {
        dataField: "scenarioID",
        text: "",
        sort: false,
        headerStyle: () => {
          return { width: "5%" };
        },
        formatter: (content, row) => {
          return (
            <Button
              color="primary"
              onClick={() => {
                setSelectedUserData({
                  userId: row.userID,
                  scenarioId: row.scenarioID,
                });
                setShowResultsModal(true);
              }}
            >
              View
            </Button>
          );
        },
      },
      {
        dataField: "scenarioID",
        text: "",
        sort: false,
        headerStyle: () => {
          return { width: "10%" };
        },
        formatter: (content, row) => {
          return (
            <Button
              color="primary"
              onClick={() => downloadReport(row.scenarioID)}
            >
              Scenario Report
            </Button>
          );
        },
      },
      {
        dataField: "scenarioID",
        text: "",
        sort: false,
        headerStyle: () => {
          return { width: "17%" };
        },
        formatter: (content, row) => {
          if (row.numParticipants > 1) {
            return (
              <Button
                color="primary"
                onClick={() => downloadConsensusReport(row.scenarioID)}
              >
                Consensus Report
              </Button>
            );
          }
        },
      },
    ];

    if (partnerScenario.ahpOnly) {
      cols = cols.filter((x) => x.text !== "# Alternatives");
      let objCol = cols.find((x) => x.text == "# Objectives");
      if (objCol != undefined) objCol.text = "# Alternatives";
    }

    setColumns(cols);
  };

  const goToEditPage = () => {
    props.history.push({
      pathname: `/decisiontemplate/${partnerId}/${partnerScenarioId}`,
    });
  };

  const downloadReport = (scenarioId) => {
    api.getScenarioReportQueryParam(currentUser.userId).then((queryParam) => {
      let url = api.getScenarioReportUrl(
        currentUser.userId,
        scenarioId,
        queryParam
      );
      var win = window.open(url, "_blank");
      win.focus();
    });
  };

  const downloadConsensusReport = (scenarioId) => {
    api.getScenarioReportQueryParam(currentUser.userId).then((queryParam) => {
      let url = api.getConsensusReportUrl(
        currentUser.userId,
        scenarioId,
        queryParam
      );
      var win = window.open(url, "_blank");
      win.focus();
    });
  };

  const togglePartnerAlternativeListModal = () => {
    if (showPartnerAlternativeListModal) {
      loadScenarios();
    }
    setShowPartnerAlternativeListModal(!showPartnerAlternativeListModal);
  };

  const getSurveyResultsReport = () => {
    var userIds = users.filter((x) => x.isSelected).map((x) => x.userID);
    if (userIds.length > 0) {
      setIsSurveyReportLoading(true);

      api.getScenarioReportQueryParam(currentUser.userId).then(
        (guid) => {
          api
            .getSurveyReport(
              currentUser.userId,
              partnerId,
              partnerScenarioId,
              guid,
              userIds
            )
            .then(
              (blob) => {
                setIsSurveyReportLoading(false);
                download(blob, "SurveyResults.xls");
              },
              (err) => setIsSurveyReportLoading(false)
            );
        },
        (err) => setIsSurveyReportLoading(false)
      );
    }
  };

  const generateSurvey = async () => {
    let tasks = users
      .filter((x) => x.isSelected)
      .map((x) => async () => {
        return await api.generateScenarios(
          x.userID,
          partnerId,
          partnerScenarioId
        );
      });
    await Promise.all(tasks.map((t) => t()));
    toast.success("Surveys generated");
    loadUsers()
  };

   const archive = async () => {
      let tasks = users
        .filter((x) => x.isSelected)
        .map((x) => async () => {
          return await api.archiveScenarios(x.userID, partnerId, partnerScenarioId);
        });
      if (tasks.length > 0) {
        await Promise.all(tasks.map((t) => t()));
        toast.success(`${partner?.decisionName ?? 'Decision'}s archived successfully`);
      }
    };

  return (
    <Fragment>
      {scenario && (
        <PageTitle
          icon="far fa-list-alt"
          style={{ paddingLeft: "0px" }}
          heading={`${scenario.partnerScenarioName}`}
        />
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {scenario && (
          <Button color="primary" size="lg" onClick={goToEditPage}>
            Edit Template
          </Button>
        )}
        {partnerScenarioId != -1 && (
          <Button color="primary" size="lg" onClick={toggleCopyTemplateModal}>
            Copy Template
          </Button>
        )}
      </div>

      {isLoading && !scenarios && (
        <Loader style={{ paddingBottom: 50 }} type="ball-pulse" active />
      )}
      <Row style={{ marginTop: "30px" }}>
        <Col md="12">
          <Card className="main-card mb-3">
            <CardBody>
              <DecisionNumberLineChart partnerScenarioId={partnerScenarioId} />
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row style={{ marginTop: "30px" }}>
        <Col md="12">
          <div style={{ width: "100%" }}>
            <div
              style={{
                width: "25%",
                display: "inline-block",
                textAlign: "center",
                padding: 10,
                color: activeTab == 1 ? colors.WHITE : colors.DODGER_BLUE,
                fontSize: 16,
                fontWeight: "bold",
                cursor: "pointer",
                backgroundColor:
                  activeTab == 1 ? colors.DODGER_BLUE : "transparent",
                border: "2px solid #4658ba",
                borderLeft: "1px",
                borderRight: "1px",
                borderTop: "0px",
              }}
              onClick={() => {
                setActiveTab(1);
              }}
            >
              {partner?.decisionName ?? "Decision"}s
            </div>
            <div
              style={{
                width: "25%",
                display: "inline-block",
                textAlign: "center",
                padding: 10,
                color: activeTab == 4 ? colors.WHITE : colors.DODGER_BLUE,
                fontSize: 16,
                fontWeight: "bold",
                cursor: "pointer",
                backgroundColor:
                  activeTab == 4 ? colors.DODGER_BLUE : "transparent",
                border: "2px solid #4658ba",
                borderLeft: "1px",
                borderRight: "1px",
                borderTop: "0px",
              }}
              onClick={() => {
                setActiveTab(4);
              }}
            >
              Users
            </div>
            <div
              style={{
                width: "25%",
                display: "inline-block",
                textAlign: "center",
                padding: 10,
                color: activeTab == 2 ? colors.WHITE : colors.DODGER_BLUE,
                fontSize: 16,
                fontWeight: "bold",
                cursor: "pointer",
                backgroundColor:
                  activeTab == 2 ? colors.DODGER_BLUE : "transparent",
                border: "2px solid #4658ba",
                borderLeft: "1px",
                borderRight: "1px",
                borderTop: "0px",
              }}
              onClick={() => {
                setActiveTab(2);
              }}
            >
              Criteria and Alternatives
            </div>
            <div
              style={{
                width: "25%",
                display: "inline-block",
                textAlign: "center",
                padding: 10,
                color: activeTab == 3 ? colors.WHITE : colors.DODGER_BLUE,
                fontSize: 16,
                fontWeight: "bold",
                cursor: "pointer",
                backgroundColor:
                  activeTab == 3 ? colors.DODGER_BLUE : "transparent",
                border: "2px solid #4658ba",
                borderLeft: "1px",
                borderRight: "1px",
                borderTop: "0px",
              }}
              onClick={() => {
                setActiveTab(3);
              }}
            >
              Data
            </div>
          </div>
        </Col>
      </Row>
      {activeTab == 2 && scenario != null && (
        <Row style={{ marginTop: "30px" }}>
          <Col md={scenario.ahpOnly ? 12 : 6}>
            <ObjectiveAverageBarChart
              partnerScenarioId={partnerScenarioId}
              partnerScenario={scenario}
            />
          </Col>

          {scenario.ahpOnly == false && (
            <Col md="6">
              <AlternativeAverageBarChart
                partnerScenarioId={partnerScenarioId}
              />
            </Col>
          )}
        </Row>
      )}
      {scenario && scenario.usePhases && activeTab == 3 && (
        <Row style={{ marginTop: "30px" }}>
          <Col md="12">
            <QuestionResultsCard partnerScenarioId={partnerScenarioId} />
          </Col>
        </Row>
      )}
      {scenarios && activeTab == 1 && (
        <Row style={{ marginTop: "30px" }}>
          <Col md="12">
            <Card className="main-card mb-3">
              <CardBody>
                {/* <Button
                color="primary"
                type="button"
                style={{width:'120px'}}
                onClick={toggleAddUserModal}
              >
                Add User
              </Button> */}
                {scenarios !== undefined &&
                  scenarios !== null &&
                  columns.length > 0 && (
                    <GeneralGrid
                      colWidth={12}
                      title="Decisions"
                      keyField="scenarioID"
                      dataSource={scenarios}
                      columns={columns}
                      defaultSortedColumn="user.firstName"
                      showAddButton={false}
                      // buttonText={"Add User"}
                      // onAdd={() => {
                      //   toggleAddUserModal();
                      // }}
                    />
                  )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}

      {activeTab == 4 && (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "20px",
              marginTop:'20px'
            }}
          >
            {scenario?.isSurvey == true && (
              <Button
                color="primary"
                type="button"
                onClick={getSurveyResultsReport}
                disabled={isSurveyReportLoading || users.filter((x) => x.isSelected).length == 0}
              >
                Survey Results Report
              </Button>
            )}
            <Button
              color="primary"
              disabled={users.filter((x) => x.isSelected).length == 0}
              onClick={generateSurvey}
            >
              Generate Survey
            </Button>
            <Button
              color="primary"
              disabled={users.filter((x) => x.isSelected).length == 0}
              onClick={archive}
            >
              Archive {partner?.decisionName ?? "Decision"}s
            </Button>
          </div>
          <UsersCard
            users={users}
            setUsers={setUsers}
            partnerScenarioId={partnerScenarioId}
            partnerId={partnerId}
            history={props.history}
            toggleAddUserModal={toggleAddUserModal}
            isSurvey={scenario.isSurvey}
            partner={partner}
          />
        </>
      )}

      <DecisionResultsModal
        selectedUserData={selectedUserData}
        showModal={showResultsModal}
        toggleModal={toggleResultsModal}
      />
      <PartnerAlternativeListModal
        showModal={showPartnerAlternativeListModal}
        toggleModal={togglePartnerAlternativeListModal}
        scenarioId={partnerAlternativeListModalScenarioId}
        setScenarioId={setPartnerAlternativeListModalScenarioId}
        props={props}
      />
      <AddUserModal
        isOpen={showAddUserModal}
        toggleModal={toggleAddUserModal}
        partnerId={partnerId}
        partnerScenarioId={partnerScenarioId}
        reload={() => {
          loadScenarios();
          loadUsers();
        }}
      />
      <CopyTemplateModal
        isOpen={showCopyTemplateModa}
        toggleModal={toggleCopyTemplateModal}
        partnerScenarioId={partnerScenarioId}
        reload={() =>
          props.history.push({
            pathname: `/decisiontemplates/${partnerId}`,
          })
        }
      />
    </Fragment>
  );
};

export default DecisionTemplateResults;
